// import React from "react";
// import NavbarComp from "../components/navbar";
// import { Container } from "react-bootstrap";

// export default function Yeshua() {
//   return (
//     <div id="Top">
//       <NavbarComp />
//       <div
//         className="container flex items-center justify-center"
//         style={{ padding: 15 }}
//       >
//         <Container style={{ padding: 15 }}>
//           <p id="RiseOfMedicalText" className=" mb-3 text-center">
//             Yeshua
//           </p>
//           <p className=" font-medium text-black text-xl text-center">
//             by Man Found Standing
//           </p>
//           <p id="paragraphStyle" className="p_text">
//             Most English-speaking people understand the name of the Messiah as
//             Jesus; however, this was not his real name. The name of ‘Jesus’ did
//             not exist until many hundreds of years later. The scholastic
//             evidence shows that Aramaic was the predominant first language of
//             the Jewish people at that time. As such, his actual birth name would
//             have been Yeshua, which is simply the Aramaic rendering of the
//             Hebrew name of Yehoshua, or Joshua which means ‘God Saves’.
//             <br />
//             <br />
//             In biblical times names were not simply random titles like our
//             modern names. Back then a person’s name held much greater
//             importance. A name represented one’s character and authority.
//           </p>
//           <p className=" ml-20 mr-20 text-red-400 text-justify italic">
//             Matthew 16:16-18 (NIV) - 16 Simon Peter answered, “You are the
//             Messiah, the Son of the living God.” 17 Jesus replied, “Blessed are
//             you, Simon son of Jonah, for this was not revealed to you by flesh
//             and blood, but by my Father in heaven. 18 And I tell you that you
//             are Peter, and on this rock I will build my church, and the gates of
//             Hades will not overcome it.
//           </p>
//           <p id="paragraphStyle" className="p_text">
//             Because of Simon’s revelation that Yeshua was the Messiah, the Son
//             of the living God, Yeshua changed Simon’s name which meant
//             ‘hearkening or listening intently’ to Peter which meant ‘rock’ both
//             in Aramaic and Greek.
//           </p>
//           <p className=" ml-20 mr-20 text-black text-justify italic">
//             Note: Now my legal first name is Paul and I like my name. Now in
//             other languages, my name gets translated. For example, Paul in
//             Spanish is converted over to Pablo a name that I don’t like the
//             sound of. (Just a personal preference.) Now when I travel down to
//             Mexico, I prefer being called Paul rather than Pablo but I still
//             answer to both and allow people the choice to what they call me.
//             Just out of respect for the Messiah and his language of birth, our
//             Church refers to Jesus as Yeshua. (I am positive he also does not
//             mind having his name translated and allows people the choice of what
//             they will call him.)
//           </p>
//           <p id="paragraphStyle" className="p_text">
//             When Joseph found out that Mary was pregnant an angel appeared to
//             him in a vision to tell him to name the boy Yeshua because he will
//             save his people from their sins (Matthew 1:20-21). Clearly, this
//             shows the importance of Yeshua’s name and it is inseparably linked
//             to him having the power and authority of the Messiah.
//           </p>
//           <p className=" ml-20 mr-20 text-red-400 text-justify italic">
//             Acts 4:12 (NIV) - 12 Salvation is found in no one else, for there is
//             no other name under heaven given to mankind by which we must be
//             saved.
//           </p>
//           <p id="paragraphStyle" className="p_text">
//             Many years after Yeshua’s resurrection the New Testament Books were
//             written in Greek. In those translations, Yeshua was translated into
//             Iēsous. Then many, many years later when the Greek was translated
//             into English the Messiah’s name became Jesus.
//           </p>
//         </Container>
//       </div>
//     </div>
//   );
// }





import React from "react";
import NavbarComp from "../components/navbar";
import { Container } from "react-bootstrap";

export default function Yeshua() {
  return (
    <div id="Top">
      <NavbarComp />
      <div className="container flex items-center justify-center px-3 md:px-5 py-4">
        <Container>
          <p
            id="RiseOfMedicalText"
            className="mb-3 text-center text-3xl font-semibold leading-snug"
          >
            Yeshua
          </p>
          <p className="font-medium text-black text-xl text-center mb-4">
            by Man Found Standing
          </p>

          <p
            id="paragraphStyle"
            className="text-justify text-base leading-relaxed text-gray-800 mb-6"
          >
            Most English-speaking people understand the name of the Messiah as
            Jesus; however, this was not his real name. The name of ‘Jesus’ did
            not exist until many hundreds of years later. The scholastic
            evidence shows that Aramaic was the predominant first language of
            the Jewish people at that time. As such, his actual birth name would
            have been Yeshua, which is simply the Aramaic rendering of the
            Hebrew name of Yehoshua, or Joshua which means ‘God Saves’.
            <br />
            <br />
            In biblical times names were not simply random titles like our
            modern names. Back then a person’s name held much greater
            importance. A name represented one’s character and authority.
          </p>

          <p className="text-red-400 italic text-justify text-sm md:text-base leading-relaxed mb-6 px-2 md:px-0">
            Matthew 16:16-18 (NIV) - 16 Simon Peter answered, “You are the
            Messiah, the Son of the living God.” 17 Jesus replied, “Blessed are
            you, Simon son of Jonah, for this was not revealed to you by flesh
            and blood, but by my Father in heaven. 18 And I tell you that you
            are Peter, and on this rock I will build my church, and the gates of
            Hades will not overcome it.
          </p>

          <p
            id="paragraphStyle"
            className="text-justify text-base leading-relaxed text-gray-800 mb-6"
          >
            Because of Simon’s revelation that Yeshua was the Messiah, the Son
            of the living God, Yeshua changed Simon’s name which meant
            ‘hearkening or listening intently’ to Peter which meant ‘rock’ both
            in Aramaic and Greek.
          </p>

          <p className="text-black italic text-justify text-sm md:text-base leading-relaxed mb-6 px-2 md:px-0">
            Note: Now my legal first name is Paul and I like my name. Now in
            other languages, my name gets translated. For example, Paul in
            Spanish is converted over to Pablo a name that I don’t like the
            sound of. (Just a personal preference.) Now when I travel down to
            Mexico, I prefer being called Paul rather than Pablo but I still
            answer to both and allow people the choice to what they call me.
            Just out of respect for the Messiah and his language of birth, our
            Church refers to Jesus as Yeshua. (I am positive he also does not
            mind having his name translated and allows people the choice of what
            they will call him.)
          </p>

          <p
            id="paragraphStyle"
            className="text-justify text-base leading-relaxed text-gray-800 mb-6"
          >
            When Joseph found out that Mary was pregnant an angel appeared to
            him in a vision to tell him to name the boy Yeshua because he will
            save his people from their sins (Matthew 1:20-21). Clearly, this
            shows the importance of Yeshua’s name and it is inseparably linked
            to him having the power and authority of the Messiah.
          </p>

          <p className="text-red-400 italic text-justify text-sm md:text-base leading-relaxed mb-6 px-2 md:px-0">
            Acts 4:12 (NIV) - 12 Salvation is found in no one else, for there is
            no other name under heaven given to mankind by which we must be
            saved.
          </p>

          <p
            id="paragraphStyle"
            className="text-justify text-base leading-relaxed text-gray-800 mb-6"
          >
            Many years after Yeshua’s resurrection the New Testament Books were
            written in Greek. In those translations, Yeshua was translated into
            Iēsous. Then many, many years later when the Greek was translated
            into English the Messiah’s name became Jesus.
          </p>
        </Container>
      </div>
    </div>
  );
}
